import CalenderLocalClock from './CalenderLocalClock';

const CalenderLocal = (props: any) => {
  return <CalenderLocalClock {...props}></CalenderLocalClock>;
};

export default CalenderLocal;
